import React from "react";
import ProcessList from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

const _ProcessList = (props) => {
  const { extra = {}, builder = false } = props;
  const { categories = [], to } = extra;

  if (categories.length === 0) {
    return <UnconfiguredComponent hint="Add categories" />;
  }

  if (!to) {
    return <UnconfiguredComponent hint="Missing to-link" />;
  }

  return <ProcessList {...props} />;
};

export default _ProcessList;
